import { FC } from 'react'
import classes from './pageCard.module.scss'

interface ProgressRingProps {
  caption: string
  // 0–100
  percent: number
  size?: number
  strokeWidth?: number
}

// Single-value ring (the card's positive share). Plain SVG instead of an
// ECharts pie: one value doesn't need a chart instance per card.
export const ProgressRing: FC<ProgressRingProps> = ({
  caption,
  percent,
  size = 84,
  strokeWidth = 8,
}) => {
  const clamped = Math.max(0, Math.min(100, percent))
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const rounded = Math.round(clamped)

  return (
    <div
      aria-label={`${rounded}% ${caption}`}
      className={classes.progressRing}
      role="img"
      style={{ height: size, width: size }}
    >
      <svg aria-hidden="true" height={size} width={size}>
        <circle
          className={classes.progressTrack}
          cx={size / 2}
          cy={size / 2}
          fill="none"
          r={radius}
          strokeWidth={strokeWidth}
        />
        <circle
          className={classes.progressValue}
          cx={size / 2}
          cy={size / 2}
          fill="none"
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - clamped / 100)}
          strokeLinecap="round"
          strokeWidth={strokeWidth}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <span className={classes.progressLabel}>
        <span className={classes.progressPercent}>{rounded}%</span>
        <span className={classes.progressCaption}>{caption}</span>
      </span>
    </div>
  )
}
